// eslint-disable-next-line import/no-extraneous-dependencies
import { components } from 'react-select'
import { ChildrenContent } from '../ChildrenContent/ChildrenContent'
import Typography from 'share-ui/components/typography/Typography'
import { useTheme } from 'styled-components'

const SingleValue = props => {
    const theme = useTheme()

    // eslint-disable-next-line react/prop-types
    const { Renderer, data, children } = props

    const value = Renderer ? (
        <Renderer {...data} />
    ) : (
        <ChildrenContent data={data}>{children}</ChildrenContent>
    )
    return (
        <components.SingleValue {...props}>
            <Typography
                value={value}
                type={Typography.types.LABEL}
                size='small'
                customColor={theme.typography.contentPrimary}
            />
        </components.SingleValue>
    )
}

export default SingleValue
